module.exports = __webpack_public_path__ + "static/media/Medicardlogoshp_New.10404545.png";